export default __webpack_public_path__ + "static/media/current_loc.ba524e92.png";